export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

/**
 * Real buyer reviews only. While these lists are empty, the page shows the
 * "Who it's for" and "Inside a session" sections in these two slots instead.
 * Example entry:
 * { quote: '...', author: 'First L.', role: 'Recreation therapist · Ohio, US', avatar: 'https://...' }
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'Before, I often walked into group without knowing where to start. Having a warm-up, a theme, and a few ways to adapt the activity helps me feel more prepared without needing to follow a script.',
    author: 'Olivia M.',
    role: 'Dance/Movement Therapist · New York, NY, US',
  },
  {
    quote:
      'Some days the group is ready to move, and other days nobody wants to participate. I like having lower-energy options ready instead of trying to invent a new activity in the moment.',
    author: 'Hannah R.',
    role: 'Registered Dance Movement Therapist · London, UK',
  },
  {
    quote:
      'I needed more than a list of movement activities. Having a beginning, a central theme, and a closing gives me a useful structure while leaving room for the group to shape the session.',
    author: 'Grace T.',
    role: 'Dance/Movement Therapy Trainee · Boston, MA, US',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'I noticed that offering seated and standing versions gave participants more ways to join in. Some chose smaller movements, and others built on the activity at their own pace.',
    author: 'Amelia C.',
    role: 'Trainee Dance Movement Psychotherapist · Manchester, UK',
  },
  {
    quote:
      'I use the session structure as a starting point, not a script. I can adapt the movement invitation to the group’s energy and leave space for participants to take things in their own direction.',
    author: 'Charlotte D.',
    role: 'Creative Arts Therapist · Los Angeles, CA, US',
  },
  {
    quote:
      'I stopped starting every session from a blank page. Now I can choose a theme and adapt it to the group I have that day.',
    author: 'Mia F.',
    role: 'Creative Arts Therapy Practitioner · Bristol, UK',
  },
]
